module.exports = __webpack_public_path__ + "img/logo-sesi.03ab8874.svg";